<template>
    <div class="full-screen-div" ref="mainPage">
        <div id="top-bar">
            <div id="top-bar-container">
                <div id="left-side-top-bar-container">
                    <img id="article-arrow" src="triangle.svg" @click="openArticles"/>
                    <div id="lextend-title">Lextend.io</div>
                </div>
                <img  id="logo" src="lextend.png" />
            </div>
        </div>
        <div id="phone-frontend-container" v-show="frontendType == 'phone'">
          <div v-show="articlesNotOpened" :id="`${frontendType}-main`">
              <div :id="`${frontendType}-mainText`" ref="mainText">
                <span>
                  <span v-for="(segment, segment_index) in cursorStyleList"
                        :key="segment_index"
                        style="margin-right: 5px;"
                    >
                      <span v-for="(word, word_index) in segment.words"
                          :key="word_index"
                          :style="word.computedStyle"
                          :class="`${frontendType}-word`"
                          style="margin-right: 5px;"
                      >
                        {{ word.word_string }}
                      </span>
                  </span>
                </span>
              </div>
              <div :id="`${frontendType}-input-container`">
                  <input :id="`${frontendType}-translation-input`" v-model="translated_word" @keyup.enter="changeWords">
              </div>
          </div>
          <div v-show="!articlesNotOpened" :id="`${frontendType}-articlesTab`">
              <router-link to="/Colors">Colors</router-link>
              <router-link to="/Foods">Foods</router-link>
              <router-link to="/GreetingsAndPhrases">Greetings and Phrases</router-link>
              <router-link to="/Numbers">Numbers</router-link>
              <router-link to="/WritingSystem">Writing System</router-link>
          </div>
        </div>
        <div id="default-frontend-container" v-show="frontendType == 'default'">
          <div id="default-articles-column" class="default-side-column">
            <div v-show="!articlesNotOpened" id="default-articlesTab">
              <router-link to="/Colors">Colors</router-link>
              <router-link to="/Foods">Foods</router-link>
              <router-link to="/GreetingsAndPhrases">Greetings and Phrases</router-link>
              <router-link to="/Numbers">Numbers</router-link>
              <router-link to="/WritingSystem">Writing System</router-link>
            </div>
          </div>
          <div id="default-main-column">
            <div :id="`${frontendType}-main`">
              <div :id="`${frontendType}-mainText`" ref="mainText">
                <span>
                  <span v-for="(segment, segment_index) in cursorStyleList"
                        :key="segment_index"
                        style="margin-right: 5px;"
                    >
                      <span v-for="(word, word_index) in segment.words"
                          :key="word_index"
                          :style="word.computedStyle"
                          :class="`${frontendType}-word`"
                          style="margin-right: 5px;"
                      >
                        {{ word.word_string }}
                      </span>
                  </span>
                </span>
              </div>
              <div :id="`${frontendType}-input-container`">
                  <input :id="`${frontendType}-translation-input`" v-model="translated_word" @keyup.enter="changeWords">
              </div>
          </div>
          </div>
          <div id="default-right-column" class="default-side-column">
            
          </div>
        </div>
        <div id="ultra-wide-frontend-container" v-show="frontendType == 'ultraWide'">
          <div id="ultra-wide-articles-section" class="ultra-wide-side">
            <div v-show="!articlesNotOpened" id="ultra-wide-articlesTab">
              <router-link to="/Colors">Colors</router-link>
              <router-link to="/Foods">Foods</router-link>
              <router-link to="/GreetingsAndPhrases">Greetings and Phrases</router-link>
              <router-link to="/Numbers">Numbers</router-link>
              <router-link to="/WritingSystem">Writing System</router-link>
          </div>
          </div>
          <div id="ultra-wide-main-section">
            <div id="ultra-wide-main">
              <div id="ultra-wide-mainText" ref="mainText">
                <span>
                  <span v-for="(segment, segment_index) in cursorStyleList"
                        :key="segment_index"
                        style="margin-right: 5px;"
                    >
                      <span v-for="(word, word_index) in segment.words"
                          :key="word_index"
                          :style="word.computedStyle"
                          class="ultra-wide-word"
                          style="margin-right: 5px;"
                      >
                        {{ word.word_string }}
                      </span>
                  </span>
                </span>
              </div>
              <div id="ultra-wide-input-container">
                  <input id="ultra-wide-translation-input" v-model="translated_word" @keyup.enter="changeWords">
              </div>
          </div>
          </div>
          <div id="ultra-wide-right-section" class="ultra-wide-side">
            
          </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { toRomaji } from 'wanakana';
import { useCookies } from "vue3-cookies";
import { useHead } from '@vueuse/head'

const { cookies } = useCookies()

export default {
  name: "Test",
  setup() {
    useHead({
      title: 'Lextend.io - Learn Japanes Naturally',
      meta: [
        {
          name: 'description',
          content: 'The most natural way to learn Japnese. Japanese learning app, app to learn Japanese, full Japanese emersion, context based Japanese learning app, japanese word practice'
        }
      ]
    })

    // ...rest of your existing setup() code, if any
  },
  components: {
    
  },
  data() {
    return {
      text: "",
      maint: "",
      firstLine: "",
      restOfSample: "",
      mainTextSample: "FESFESD",   
      articlesNotOpened: true,
      testStruct: [{},{}],
      translated_word: '',
      segments: [],
      currWord: null,
      best_segment: null,
      currIndex: -1,
      next_word: null,
      my_vetted_pkgs_index: 0,
      unedited_pkgs_index: 0,
      changing_to_unedited_state: false,
      pkgs: null,
      last_index: null,
      debug_status: false,
      cursorStyleListEdited: [],
      frontendType: '',
      testValue: 0,
    };
  },
  beforeMount() {
    // This code will be executed before the component is mounted to the DOM
    this.debug_status = process.env.NODE_ENV === "development"
    console.log("debug status: ", this.debug_status)
    // if (!this.debug_status && ){
    this.getMode();
    // }
    // console.log(process.env.NODE_ENV == "development")
  },
  mounted() {
    this.my_vetted_pkgs_index = 10;
    this.setRatioMainPage();
    window.addEventListener("resize", this.setRatioMainPage)
  },
  beforeUnmount() {

  },
  methods: {
    setRatioMainPage() {
      var mainPageRef = this.$refs.mainPage;

      if (mainPageRef) {
        var mainPageDiv = mainPageRef.getBoundingClientRect();

        var mainPageWidth = mainPageDiv.width; 
        var mainPageHeight = mainPageDiv.height;
        var mainPageRatio  = mainPageHeight / mainPageWidth;

        
        console.log(mainPageWidth);
        console.log(mainPageHeight);
        console.log(mainPageRatio);

        if (mainPageRatio > 3/4 ){
          // case of the phone frontend
          this.frontendType = "phone"
        } else if (mainPageRatio <= 3/4 && mainPageRatio > 9/21) {
          //case of normal
          this.frontendType = "default"
        } else {
          // case of ultra wide
          this.frontendType = "ultraWide"
        }

        console.log(this.testValue, this.frontendType, this.articlesNotOpened);
        this.testValue++;
        this.$forceUpdate();
      }
    },
    openArticles() {
        console.log("getting called", !this.articlesNotOpened);
        this.articlesNotOpened = !this.articlesNotOpened;
        this.$forceUpdate()
    },
    testCookie(){
      ////console.log(this.cookieValue)
    },
    createWordsMatrix(paragragh) {
      ////console.log(this.gridWidth)
      ////console.log(paragragh)

      var matrix = [];
      var curWidth = 0;
      var subMatrix = []
      var row = 0;
      var str = '';


      for (let i = 0; i < paragragh.length; i++) {
        if (curWidth + this.measureCharacterWidth(paragragh[i]) >= this.gridWidth) {
          // create new subMatrix

          matrix.push({"str": str, "words": subMatrix, "width": curWidth, "row": row});
          curWidth = 0;
          subMatrix = [];
          row += 1;
          str = '';
        }

        str += paragragh[i];
        ////console.log(this.measureCharacterWidth(paragragh[i]));

        subMatrix.push({"char" : paragragh[i], "width" : this.measureCharacterWidth(paragragh[i])});
        curWidth += this.measureCharacterWidth(paragragh[i]);

        //////console.log(this.measureCharacterWidth(paragrag[i]));
      }

      if (subMatrix.length != 0) {
        matrix.push({"str": str, "words": subMatrix, "width": curWidth, "row": row})
      }
      
      ////console.log(matrix)

      return matrix
    },
    getGridWidth() {
      // Use the ref to access the DOM element
      const gridContainer = this.$refs.gridContainer;
      if (gridContainer) {
        this.gridWidth = gridContainer.getBoundingClientRect().width;
        ////console.log(`Grid Container Width: ${this.gridWidth}px`);
      }
    },
    findNextWord(){
      return
    },
    increasePosition(got_correct){

      var newVal = this.words.slice().splice(this.currIndex + 1, this.words.length - (this.currIndex + 1))?.find(word => word?.def !== "NO_MEANING")?.index;


      if (newVal !== undefined) {
        this.words[this.currIndex].got_correct = got_correct
        //this.words[this.currIndex].got_correct = got_correct; 
        ////console.log("WE CHANGED THE VAL: ", this.words[this.currIndex].got_correct)
        this.currIndex = newVal;
        this.next_word = this.words[this.currIndex];
      }

    },
    measureCharacterWidth(charInput) {
      // Ensure the input is a single character
      var charWidth = 0
      if (charInput.length === 1) {
        // Create an invisible canvas to measure the character's width
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        
        // Set the font style (ensure it matches the font used in your element)
        ctx.font = "16px Arial";  // Adjust the font style as needed
        
        // Measure the width of the character
        charWidth = ctx.measureText(charInput).width;
      } 

      return charWidth
    },
    create_sentence(words) {
    var mainStr = "";

    for (let i = 0; i < words.length; i++) 
    {
      ////console.log(words[i].word);

      mainStr += words[i].word;
      ////console.log(words[i].word[0])
      ////console.log(this.measureCharacterWidth(words[i].word[0]))
      ////console.log(this.measureCharacterWidth('a'))

      ////console.log(mainStr)
      
    } 

    return mainStr
    },
    async getMode(){
      const apiUrl = "https://api.lextend.io/api/getMode";
      
      ////console.log("print this is called");

      await axios
        .get(apiUrl)
        .then((response) => {
          ////console.log(response.data);
          this.mode = eval(response.data);

          // after figuring out which mode we are in this proceed
          if(this.mode == "3") {
            ////console.log("going 3")
            this.fetchVocab();
          } else if (this.mode == "2") {
            this.fetchSentence();
          }
        })
        .catch((error) => {
          this.error = "Error fetching users.";
          console.error(error);
        });
      return 
    },
    async fetchVocab(){
      const apiUrl = "https://api.lextend.io/api/getVocab";

      // Making the GET request with Axios
      await axios
        .get(apiUrl)
        .then((response) => {
          ////console.log(response.data)
          this.vocab = eval(response.data);

          if(this.vocab != [] && this.mode == "2"){
            //this.fetchSentenceOnScore();
            this.fetchSentenceOnVocab();
          } else if(this.mode == "2") {
            this.fetchSentenceOnScore();
          } else if (this.mode == "3") {
            ////console.log("fetching sentence in 3")
            this.fetchSentence();
          }
          ////console.log(this.vocab)
        })
        .catch((error) => {
          this.error = "Error fetching users.";
          console.error(error);
        });
      return 
    },
    sameWords(word1, word2) {
      //////console.log("comparing words: ", word1 == word2)
      if (word1.word_string === word2.word_string && word1.reading === word2.reading  && word1.type === word2.type  && word1.grammar_score === word2.grammar_score  && word1.difficulty_score === word2.difficulty_score){
        return true
      }

      return false
    },
    sameSegments(seg1, seg2) {
      if (seg1.num_segs !== seg2.num_segs){
        return false;
      } else {

        for (let i = 0; i < seg1.words.length; i++) {
          if (!this.sameWords(seg1.words[i], seg2.words[i])) {
            return false
          }
        }

        return true
      }
    },
    checkIfEndOfSentence(){
      // this is called right after every guess
      // case we are  have guessed the last word

      //console.log(this.segments, "pre slice")
      //console.log(this.segments.slice(this.currIndex));
      //console.log(this.segments, "post slice")
      //console.log(this.currIndex);
      //console.log(this.currWord);
      //console.log(this.last_index)

        // this.currIndex refers to the WORD 
        // not the SEGMENT 

        // find the segment index that correlates with the word_index

      var segment_index = this.segments.findIndex((segment) => segment.words.some(word => word.index == this.currIndex));

      if (!(this.segments.slice(segment_index).find(segment => segment.words.find(word => word.meaning != null || (word.reading != "" && word.reading != null)))) || this.currWord.index == this.last_index) {

        // just increment
        //console.log("end of sentence is being triggered", this.currWord.index == this.last_index);
        this.my_vetted_pkgs_index++;

        this.fetchSentence();
        return true                                                                                   
      }
      return false
    },
    setNextWord(){
      // set the index of the first word that has a meaning or a reading 
      this.segments.find((segment) => segment.words.find((word) => {
      ////console.log(word.meaning, word.reading, word, this.currIndex)
      ////console.log((word.meaning != null || (word.reading !== ""  && word.reading !== null)), (word.index > this.currIndex))
      ////console.log(word.meaning != null, (word.reading !== ""  && word.reading !== null))
      ////console.log((word.meaning != null || (word.reading !== ""  && word.reading !== null)) && (word.index > this.currIndex))
      // //console.log(word)
      // //console.log(this.currIndex)

        if ((word.meaning != null || (word.reading !== ""  && word.reading !== null)) && (word.index > this.currIndex)) {
          ////console.log("setting word")
          this.currWord = word;
          this.currIndex = this.currWord.index;
          // //console.log("set next word: ", word);
          return word
        }
      }))

    },
    setLastIndex(){
      // the last VIABLE word not 
      // determine the last index
      // let total_words = 0;

      // this.segments.forEach((segment) => {total_words += segment.words.length});

      // this.last_index = total_words - 1;
      ////console.log(this.last_index);

      // var reversed_segs = this.segments;
      // reversed_segs.reverse();
      // var words = [];

      for (let i = this.segments.length - 1; i >= 0; i--) {
        for (let j = this.segments[i].words.length - 1; j >= 0; j--) {
          // //console.log(this.segments[i].words[j]);
          if(this.segments[i].words[j].meaning != null || (this.segments[i].words[j].reading != "" && this.segments[i].words[j].reading != null)) {
            //console.log("last index", this.segments[i].words[j])
            this.last_index = this.segments[i].words[j].index;
            return
          }
        }
      }

    },
    resetPageData() {
      this.translated_word = '';
      this.segments = [];
      this.currWord = null;
      this.best_segment = null;
      this.currIndex = -1;
      this.next_word = null;
      // my_vetted_pkgs_index: 0,
      this.last_index = null;
    },
    fetchSentenceApi(apiUrl) {
      //const apiUrl = "https://api.lextend.io/api/getSentence";

      // Making the GET request with Axios
      return axios.get(apiUrl);
        // .then((response) => {

          // this.resetPageData()
          // //console.log(response.data, this.my_vetted_pkgs_index);

          // if (this.my_vetted_pkgs_index <= 10) {
          //   var pkgs = response.data;
          //   var pkg = pkgs[this.my_vetted_pkgs_index];
          //   this.segments = pkg.segments;
          //   this.best_segment = pkg.best_segment;
          // } else {

          // }


          ////console.log("post intial")


        // })
        // .catch((error) => {
        //   this.error = "Error fetching pkgs.";
        //   //console.error(error);
        // });
    },
    fetchSentence() {
      // concept of this function?
      // it sounds like you are just getting data
      // But the way it is used is getting data and implementing it
      // just make it do both but it's different 
      
      // check if we need to get new data 
      // case 1 edited pkgs
      // case 2 unedited pkgs 

      if (this.my_vetted_pkgs_index <= 9) {
        // need to fetch the edited pkgs anytime 
        // that the indedx is less than 10 since someone
        // could have left after < 10 pkgs
        // But if we already have data we can just
        // increment

        // check the premount / mount state inorder to get data
        //console.log(this.segments.length == 0, this.best_segment);
        if(this.segments.length == 0 && this.best_segment == null) {
          const apiUrl = "https://api.lextend.io/api/getEditedSentence";

          this.fetchSentenceApi(apiUrl).then((response) => {
            // need to set pkgs aned increment
            
            // reset the page 
            this.resetPageData();
            this.pkgs = response.data;

            //console.log(this.pkgs);

            // var pkgs = response.data;
            var pkg = this.pkgs[this.my_vetted_pkgs_index];
            this.segments = pkg.segments;
            this.best_segment = pkg.best_segment;

            this.finishSettingUp();

          }).catch((error) => {
            this.error = "Error fetching edited pkgs.";
            console.error(error);
          });
        } else {

          // reset the page 
          this.resetPageData();

          this.setCookie(this.my_vetted_pkgs_index)
          this.my_vetted_pkgs_index = this.getCookie("vetted_pkgs")

          // console.log("cookie test: ", this.my_vetted_pkgs_index);
        
          var pkg = this.pkgs[this.my_vetted_pkgs_index];
          this.segments = pkg.segments;
          this.best_segment = pkg.best_segment;

          this.unedited_state = this.my_vetted_pkgs_index > 10 ? true : false;

          this.finishSettingUp();
        }
      } else {
        // we know that we arent in a edited state

        // but we dont know whether we need to get the data or 
        // increment the data we have

        // case 1 we know that we are in not edited and we are setting up 
        // case 2 changing from edited to unedited 
        // case 3 end of a unedited pkg list

        // picking 9 since it is the tenth index
        //console.log("going to unedited", this.segments.length == 0, this.best_segment == null)
        if (this.segments.length == 0 && this.best_segment == null || this.changing_to_unedited_state || this.unedited_pkgs_index == 9) {
          // case of previously dont edited pkgs and we are setting up
          const apiUrl = "https://api.lextend.io/api/getUneditedSentence";
          
          // set pkg data
          this.fetchSentenceApi(apiUrl).then((response) => {
            // need to set pkgs aned increment

            // reset the page 
            this.resetPageData();

            // set index 
            this.unedited_pkgs_index = 0;

            this.pkgs = response.data;

            var pkg = this.pkgs[this.unedited_pkgs_index];
            this.segments = pkg.segments;
            this.best_segment = pkg.best_segment;


            this.finishSettingUp();

          }).catch((error) => {
            this.error = "Error fetching edited pkgs.";
            console.error(error);
          });
        } else {
          // debugger;
          // reset the page 
          this.resetPageData();

          // increment 
          this.unedited_pkgs_index++;
          // case of unedited loaded case
          pkg = this.pkgs[this.unedited_pkgs_index];
          this.segments = pkg.segments;
          this.best_segment = pkg.best_segment;

          this.finishSettingUp();
        }
      }
    },
    finishSettingUp(){

      //console.log(this.segments, this.best_segment, "pre");

      var curr_index = -1

      this.segments = this.segments.map((segment) => ({num_segs: segment.num_segs, words: segment.words.map((word) => ({...word, index: curr_index +=1, got_correct : null, part_of_best_segment : this.sameSegments(segment,this.best_segment)})), string_value: segment.words.map(word => word.word_string).join("")}));

      //console.log(this.segments, "post")

      this.setLastIndex();
      this.setNextWord();

      this.loading = false;
    },
    normalizeToAscii(str) {
      return str.replace(/[\uFF01-\uFF5E]/g, ch =>
        String.fromCharCode(ch.charCodeAt(0) - 0xFF00 + 0x20)
      ).replace(/\u3000/g, ' '); // also normalize full-width space
    },
    checkIfWordIsCorrect(){

      console.log(this.currWord ,this.translated_word)

      if (this.normalizeToAscii(this.currWord.word_string) === this.translated_word || this.translated_word !== "" ? (this.currWord.meaning?.some(el => el?.toLowerCase() === this.translated_word?.toLowerCase()) || toRomaji(this.currWord?.reading == null ? "" : this.currWord?.reading)?.toLowerCase() === this.translated_word?.toLowerCase()) : false) {
        this.currWord.got_correct = true;
      } else {
        this.currWord.got_correct = false;
      }

      // rerturns if it is the end of a sentence 
      return this.checkIfEndOfSentence();

    },
    changeWords(){
      //console.log("changing words");

      
      // this function returns whether it is the end of the sentence 
      if(!this.checkIfWordIsCorrect()) {
        this.setNextWord();
      }
      this.translated_word = '';
    },
    setCookie(val){
      cookies.set('vetted_pkgs', val, 'Infinity')
      //alert('Cookie set!')
    },
    getCookie(cookie_name){
      this.cookieValue = cookies.get(cookie_name) || 'No cookie found.';
      return this.cookieValue;
    },
  },
  computed: {
    splitText() {
        return this.text.split(" ");
    },
    cursorStyleList() {
      return this.segments.map(segment => ({  
         ...segment,
         words : segment.words.map((word) => {
          if (word.Meaning == null) { 
            return {
              ...word,
              computedStyle: {
                  'border-left': `${word.index === this.currIndex ? '2px solid grey' : '2px solid transparent'}`,
                  'font-size': '20px',
                  'font': 'arial',
                  'box-sizing':' border-box',
                  'fontFamily': 'Arial', 
                  'color': word.got_correct != null ? word.got_correct == true ? 'green' : 'red' : `${word.part_of_best_segment ? '#8080ff' : word.type == "DET" || word.type == "COPULA" || word.type == "NOUN" || word.type == "CONJUNCTION" || word.type == "ADVERB" || word.type == "SUFFIX" || word.type == "CONJUNCTION" ||word.type == "PREFIX" || word.type == "ADJECTIVE" || word.type == "ADJ" || word.type == "ADV" || word.type == "PROPN" || word.type == "PRON" || word.type == "PART"  || word.type == "AUX" || word.type== "VERB" ? ' #008080' : word.type == "PARTICLE" ? "#ff7733" : "#212529"}`,
                }
            };
          } else {
            return {
              ...word,
              computedStyle: {
                  'border-left': `${word.index === this.currIndex ? '2px solid grey' : '2px solid transparent'}`,
                  'font-size': '20px',
                  'font': 'arial',
                  'box-sizing':' border-box',
                  'fontFamily': 'Arial', 
                  'color': word.got_correct != null ? word.got_correct == true ? 'green' : 'red' : `${word.part_of_best_segment ? '#8080ff' : word.type == "DET" || word.type == "COPULA" || word.type == "NOUN" || word.type == "ADVERB" || word.type == "CONJUNCTION" || word.type == "SUFFIX" ||word.type == "PREFIX" || word.type == "ADJ" || word.type == "ADJECTIVE" || word.type == "ADV" || word.type == "PROPN" || word.type == "PRON" || word.type == "PART"  || word.type == "AUX" || word.type== "VERB" ? ' #008080' : word.type == "PARTICLE" ? "#ff7733" : "#212529"}`,
                  'textDecoration': 'underline',
                  'text-underline-offset': '2px'
                }
            };
          }
         }), 
      }));
    }
  }
};
</script>
<!-- top bar section -->

<style scoped>

#left-side-top-bar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.full-screen-div {
        width: 100vw; /* 100% of the viewport width */
        height: 100vh; /* 100% of the viewport height */
}

#lextend-title {
    color: white;
    font-size: 36px;
    margin-left: 20px;
    padding: 0px 10px 5px 0px;
}

#top-bar-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
}

#top-bar {
    width: 100vw;
    height: 75px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #34495e;

}

#article-arrow {
    width: auto;
    height: 20px;
    cursor: pointer;
}

#logo {
    width: auto;   /* shrink */
    height: 50px;   /* keep aspect ratio */
}


</style>

<!-- main section  -->
<style scoped>

/* phone section */

.phone-word {
  font-size: 100px;
}

.phone-mainTextElement {
   /*  white-space: nowrap; prevents text from wrapping */
   /* overflow: hidden;      hides overflow text */
}

#phone-main {
    height: calc(100vh - 75px);
    width: 100vw;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between; 
    padding: 75px;
}

#phone-mainText {
  height: calc(55vh - 75px);
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  /* font-size: 200px; */
}

#phone-translation-input {
    width: 100%;
}

#phone-input-container {
    margin-top: 50px;
    height: calc(45vh + 75px);
}

/* default */

#default-frontend-container {
  height: calc(100vh - 75px);
  width: 100vw;
  background-color: white;
  display: flex;
  flex-direction: row;
}

.default-side-column {
  width: 28%;
}

#default-main-column {
  padding: 75px;
  width: 44%;
}

#default-main {
  height: 100%;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}

#default-mainText {
  height: 55%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}

#default-translation-input {
  width: 100%;
}

#default-input-container {
  height: 45%;
}

/* ultra wide */ 

#ultra-wide-frontend-container {
  height: calc(100vh - 75px);
  width: 100vw;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.ultra-wide-side {
  width: 500px;
}

#ultra-wide-main-section {
  width: 800px;
  padding: 75px;
}

#ultra-wide-main {
  height: 100%;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}

#ultra-wide-mainText {
  height: 55%;  
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}

#ultra-wide-translation-input {
  width: 100%;
}

#ultra-wide-input-container {
  height: 45%;
}

</style>

<!-- article tabs section -->
<style scoped> 

/* phone styles */

#phone-articlesTab {
    height: calc(100vh - 75px);
    width: 100vw;
    background-color: white;
    display: flex;
    flex-direction: column;
}

#phone-articlesTab a{
    background-color: #34495e;
    color: white; 
    height: 75px;
    width: 100vw;
    margin: 2px 0 0 0 ;
    padding: 20px;
    font-size: 30px;
    text-align: middle;
    display: flex;
    align-items: center;     /* vertical */
    text-decoration: none;
    transition: background 0.3s;
}

#phone-articlesTab a:hover {
      background-color: #1abc9c;
}

/* default */


#default-articles-column {
  padding: 0px;
}

#default-articles-column a{
    background-color: #34495e;
    color: white; 
    height: 75px;
    width: 100%;
    margin: 2px 0 0 0 ;
    font-size: 30px;
    text-align: middle;
    display: flex;
    align-items: center;     /* vertical */
    text-decoration: none;
    transition: background 0.3s;
    padding: 20px;
}

#default-articles-column a:hover {
      background-color: #1abc9c;
}

/* ultra wide styling*/ 

#ultra-wide-articlesTab {
    height: 100%;
    width: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
}

#ultra-wide-articlesTab a{
    background-color: #34495e;
    color: white; 
    height: 75px;
    margin: 2px 0 0 0 ;
    padding: 20px;
    font-size: 30px;
    text-align: middle;
    display: flex;
    align-items: center;     /* vertical */
    text-decoration: none;
    transition: background 0.3s;
}

#ultra-wide-articlesTab a:hover {
      background-color: #1abc9c;
}


</style>